<script lang="ts">
import { AccountManager } from "./account-manager.ts";

export default AccountManager;
</script>

<template>
    <div class="account-manager">
        <div class="account-manager__head">{{ initials }}</div>
        <div class="account-manager__body">
            <div class="account-manager__content">
                <div class="account-manager__title">
                    <i18n-t
                        keypath="dashboard.myAccountComponent.contactInfoTab.managerLabel"
                    />
                </div>
                <div class="h5">
                    {{ accountManager?.firstname }} {{ accountManager?.lastname }}
                </div>
                <a
                    v-if="accountManager?.email"
                    class="account-manager__link"
                    :href="`mailto:${accountManager?.email}`"
                >
                    {{ accountManager.email }}
                </a>
                <a
                    v-if="accountManager?.phone"
                    class="account-manager__link"
                    :href="`tel:${accountManager?.phone}`"
                >
                    {{ accountManager.phone }}
                </a>
                <a
                    v-if="accountManager?.phone_mobile"
                    class="account-manager__link"
                    :href="`tel:${accountManager?.phone_mobile}`"
                >
                    {{ accountManager.phone_mobile }}
                </a>
            </div>
            <div class="account-manager__content">
                <div class="account-manager__title">
                    <i18n-t
                        keypath="dashboard.myAccountComponent.contactInfoTab.language"
                    />
                </div>
                <div class="account-manager__languages">
                    <div
                        v-for="lang in accountManager?.supported_languages"
                        :key="lang.id"
                        class="button button--outline button--sm"
                    >
                        {{ lang.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import "../../../shared/styles/mixins";

.account-manager {
    width: 100%;
    border-radius: c-rem(4);
    background: var(--color-surface-highest);
    box-shadow: 0px c-rem(30) c-rem(60) 0px rgba(40, 55, 71, 0.1),
        0px c-rem(40) c-rem(80) c-rem(-40) rgba(15, 106, 177, 0.1),
        0px c-rem(24) c-rem(20) c-rem(-20) rgba(40, 55, 71, 0.15);
    margin-bottom: c-rem(30);

    &__head {
        height: c-rem(163);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--color-primary-lowest);
        color: var(--color-primary);
        text-transform: uppercase;
        font-size: c-rem(28);
        line-height: c-rem(34);
        letter-spacing: 1px;
        font-weight: 500;
    }
    &__body {
        display: flex;
    }
    &__content {
        width: 50%;
        display: flex;
        flex-direction: column;
        padding: c-rem(16) c-rem(24);
        position: relative;
        &:nth-child(2) {
            &:before {
                content: "";
                display: block;
                position: absolute;
                width: 1px;
                height: calc(100% - 2rem);
                left: 0;
                border-left: 1px solid var(--color-gray-soft);
            }
        }
        .h5 {
            margin-bottom: c-rem(4);
        }
    }
    &__title {
        font-size: c-rem(13);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: var(--color-text-gray);
        margin-bottom: c-rem(4);
    }
    &__languages {
        display: flex;
        gap: c-rem(8);
        flex-wrap: wrap;
        .button {
            color: #627690;
        }
    }
    &__link {
        text-decoration: none;
        color: var(--color-primary);
        font-size: c-rem(13);
        line-height: c-rem(22);
    }
}
</style>
